import { useTranslation } from 'react-i18next'

import { useWidgetContext, WidgetContentItemsList } from '../../../../Widget'
import {
  getViewingApplicantsFormInitialValues,
  getViewingPrimaryApplicantId,
} from '../RentalPortalViewingProfileWidgetApplicants.utils'
import { ViewingApplicantsForm } from '../ViewingApplicantsForm'
import { ViewingApplicantsItem } from '../ViewingApplicantsItem'

function ViewingApplicantsContent({
  applicants,
  canManage,
  deletingApplicantId,
  listingId,
  onDelete,
  onSubmit,
}) {
  const { t } = useTranslation()

  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  return (
    <>
      <WidgetContentItemsList
        Item={ViewingApplicantsItem}
        emptyStateText={t('RentalPortal.ViewingApplicantsEmptyKey')}
        itemProps={{
          canDelete: canManage,
          deletingApplicantId,
          onDelete,
        }}
        items={applicants}
      />
      {isEditMode ? (
        <ViewingApplicantsForm
          initialValues={getViewingApplicantsFormInitialValues(applicants)}
          listingId={listingId}
          primaryApplicantId={getViewingPrimaryApplicantId(applicants)}
          onClose={handleDisableEditMode}
          onSubmit={onSubmit}
          onSuccess={handleDisableEditMode}
        />
      ) : null}
    </>
  )
}

export default ViewingApplicantsContent
